import { FC, useEffect, useState } from 'react';
import EditorImg from 'lowcode/components/EditorImg';
import { message, Modal } from 'antd-v5';
import EditorLink from 'lowcode/components/EditorLink';
import { getMemberHolidayStatistics, checkWinningList, getWinningList } from '../../../apis';
import { EnergyIcon, RightIcon, WinnerLeft, WinnerRight } from '../../Svg';
import styled from './index.module.scss';
import { activityId, MAX_ENERGY, partition, productImgList } from './config';
import { useLang } from '@/app/utils/useLang';
import getLocal from '@/app/utils/getLocal';
import { useMembersStore } from '@/components/MembersDay/MembersProvider';
import EfImg from '@elem/ui/ef-img';

interface IProps {
    type?: string;
}

const Energy: FC<IProps> = ({}) => {
    const { t } = useLang('membersday.membersdayenergy25');
    const { isLogin } = useMembersStore();
    const [showRules, setShowRules] = useState(false);
    const [showLucky, setShowLucky] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [energyNum, setEnergyNum] = useState('0');
    const [winnerList, setWinnerList] = useState<{ productImg: string; productName: string; nameList: string[] }[]>([]);
    const { locale, pathname } = getLocal();
    const max_energynum = MAX_ENERGY[locale] || MAX_ENERGY.us;
    const imgList = productImgList[locale] || productImgList.us;
    const initData = () => {
        checkWinningList(locale, activityId).then((res) => {
            if (res.code !== '0') return message.error(res.message);
            const hasWinnerList = res.data.some((item: any) => item.hasWinnerList);
            setDisabled(!hasWinnerList);
        });
        getMemberHolidayStatistics(locale).then((res) => {
            if (res.code !== '0' || !res.data) return message.error(res.message);
            setEnergyNum(res.data.totalSceneValue > max_energynum ? max_energynum : res.data.totalSceneValue);
        });
    };

    // 千分位
    const formatNumber = (num: string, locale: string) => {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, partition[locale] || ',');
    };

    const handleGetWinningList = () => {
        if (disabled) return message.error(t('membersdayenergy_tips'));
        getWinningList(locale, activityId).then((res) => {
            if (res.code !== '0') return message.error(res.message);
            // res.data = {
            //     '1': ['123@qq.com', '2345@qq.com'],
            //     '2': ['123@qq.com', '2345@qq.com'],
            // };
            const list = [] as { productImg: string; productName: string; nameList: string[] }[];
            Object.values(res.data).map((item: any) => {
                list.push({
                    productName: '',
                    productImg: '',
                    nameList: item,
                });
            });
            if (list[0]) {
                list[0].productName = t('membersdayenergy_name');
                list[0].productImg = imgList[0];
            }
            if (list[1]) {
                list[1].productName = t('membersdayenergy_name2');
                list[1].productImg = imgList[1];
            }
            setWinnerList(list);
            setShowLucky(true);
        });
    };

    useEffect(() => {
        initData();
    }, []);
    const list = [
        {
            img: imgList[0],
            value: t('membersdayenergy_value'),
            name: t('membersdayenergy_name'),
            lucky: t('membersdayenergy_lucky'),
            total: t.rich('membersdayenergy_projress', {
                light: (text: string) => <span>{text}</span>,
                point: formatNumber(energyNum, locale),
            }),
            number: t('membersdayenergy_number'),
        },
        {
            img: imgList[1],
            value: t('membersdayenergy_value2'),
            name: t('membersdayenergy_name2'),
            lucky: t('membersdayenergy_lucky2'),
            total: '',
            number: t('membersdayenergy_number2'),
        },
    ];
    return (
        <div className={styled.Energy} id="energy">
            <div className="energy-header">
                <h5 className="title">{t('membersdayenergy_header')}</h5>
                <p className="desc">{t('membersdayenergy_desc')}</p>
                {!isLogin && (
                    <EditorLink
                        dataLayer={{
                            event: 'uaEvent',
                            event_name: 'activity_join',
                            button_name: `${t('membersdayenergy_header')}_${t('membersdayenergy_now')}`,
                            list_name: t('membersdayenergy_header'),
                        }}
                        className="jon-btn"
                        href={`/${locale}/register?redirect=${encodeURIComponent(`/${locale}${pathname}#energy`)}`}
                    >
                        {t('membersdayenergy_now')}
                    </EditorLink>
                )}
                {!isLogin && (
                    <p className="already">
                        {t.rich('membersdayalready', {
                            link: (text: string) => (
                                <EditorLink
                                    dataLayer={{
                                        event: 'uaEvent',
                                        event_name: 'activity_join',
                                        button_name: `${t('membersdayenergy_header')}_${text}`,
                                        list_name: t('membersdayenergy_header'),
                                    }}
                                    href={`/${locale}/login?redirect=${encodeURIComponent(`/${locale}${pathname}#energy`)}`}
                                >
                                    {text}
                                </EditorLink>
                            ),
                        })}
                    </p>
                )}
            </div>
            <div className="energy-box">
                {list.map((item) => (
                    <div className="energy-item" key={item.number}>
                        <div className="energy-product-card">
                            <div className="free">{t('membersdayenergy_free')}</div>
                            <EnergyIcon className="lightning" />
                            <EditorImg classes="img" pc={item.img} />
                            <p className="value">{item.value}</p>
                            <p className="name">{item.name}</p>
                            <p className="lucky">{item.lucky}</p>
                        </div>
                        {item.total && <p className="energy-total">{item.total}</p>}
                        <div className="energy-progress">
                            <span className="number">{item.number}</span>
                        </div>
                    </div>
                ))}
            </div>
            <div className="energy-tools">
                <EditorLink className="link" onClick={() => setShowRules(true)}>
                    {t('membersdayenergy_rules')}
                    <RightIcon />
                </EditorLink>
                <EditorLink
                    dataLayer={{
                        event: 'uaEvent',
                        event_name: 'activity_button',
                        page_name: 'members-festival',
                        list_name: 'Power Up the Pool Together',
                        button_name: t('membersdayenergy_luckymembers'),
                        function: 'Lucky Members Popup',
                    }}
                    className="link"
                    onClick={handleGetWinningList}
                >
                    {t('membersdayenergy_luckymembers')}
                    <RightIcon />
                </EditorLink>
            </div>
            <Modal className={styled.festivalModal} centered maskClosable={false} open={showRules} footer={null} onCancel={() => setShowRules(false)}>
                <div className="header">{t('membersdayenergy_rules')}</div>
                <div className="content">
                    <p className="rule-title">{t('membersdayenergy_rules_title')}</p>
                    <p className="rule-content">{t('membersdayenergy_rules_content')}</p>
                </div>
            </Modal>
            <Modal className={styled.festivalModal} centered maskClosable={false} open={showLucky} footer={null} onCancel={() => setShowLucky(false)}>
                <div className="winner-header">
                    <p className="winner-title">{t('membersdayenergy_winner_title')}</p>
                    <p className="winner-desc">{t('membersdayenergy_winner_desc')}</p>
                    <div className="winner-img">
                        <EfImg
                            pc="https://websiteoss.ecoflow.com/upload/image/1741505324684/gold-bg-pc.png"
                            pad="https://websiteoss.ecoflow.com/upload/image/1741505324684/gold-bg-pc.png"
                            h5="https://websiteoss.ecoflow.com/upload/image/1741505263203/gold-bg.png"
                        />
                    </div>
                </div>
                <ul className="winner-content">
                    {winnerList.map((item) => (
                        <li className="winner-item" key={item.productName}>
                            <div className="name-box">
                                {item.nameList.map((item) => (
                                    <p key={item}>{item}</p>
                                ))}
                                {['fr', 'es', 'it', 'kr'].includes(locale) ? (
                                    <p className="text">
                                        {t.rich('membersdayenergy_winner_receive', {
                                            product: item.productName,
                                        })}
                                    </p>
                                ) : (
                                    <>
                                        <p className="text">{t('membersdayenergy_winner_receive')}</p>
                                        <p>{item.productName}</p>
                                    </>
                                )}
                            </div>
                            <div className="product-img">
                                <WinnerLeft className="left" />
                                <EditorImg classes="img" pc={item.productImg} />
                                <WinnerRight className="right" />
                            </div>
                        </li>
                    ))}
                </ul>
            </Modal>
        </div>
    );
};

export default Energy;
